import type React from 'react';

export type FlexingProps = {
  flex?: number;
  flexDirection?: React.CSSProperties['flexDirection'];
  justifyContent?: React.CSSProperties['justifyContent'];
  alignItems?: React.CSSProperties['alignItems'];
  flexWrap?: React.CSSProperties['flexWrap'];
  flexBasis?: React.CSSProperties['flexBasis'];
  flexGrow?: React.CSSProperties['flexGrow'];
  flexShrink?: React.CSSProperties['flexShrink'];
};

const sizeProps = [
  'flex',
  'justifyContent',
  'alignItems',
  'flexDirection',
  'flexWrap',
  'flexGrow',
  'flexBasis',
  'flexShrink',
];

export const formatFlexing = (props: FlexingProps) => {
  const styles: string[] = [];
  for (const key of sizeProps) {
    const value = props[key as keyof FlexingProps];

    if (value === undefined) {
      continue;
    }

    switch (key) {
      case 'flex':
        styles.push(`flex: ${value};`);
        break;
      case 'justifyContent':
        styles.push(`justify-content: ${value};`);
        break;
      case 'alignItems':
        styles.push(`align-items: ${value};`);
        break;
      case 'flexDirection':
        styles.push(`flex-direction: ${value};`);
        break;
      case 'flexWrap':
        styles.push(`flex-wrap: ${value};`);
        break;
      case 'flexGrow':
        styles.push(`flex-grow: ${value};`);
        break;
      case 'flexBasis':
        styles.push(`flex-basis: ${value};`);
        break;
      case 'flexShrink':
        styles.push(`flex-shrink: ${value};`);
        break;
      default:
        break;
    }
  }
  return styles.join('\n');
};
